// extracted by mini-css-extract-plugin
export var smallSpinner = "_qc-0";